import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=11da4a8c"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=11da4a8c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11da4a8c')) {
      api.createRecord('11da4a8c', component.options)
    } else {
      api.reload('11da4a8c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=11da4a8c", function () {
      api.rerender('11da4a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/QIP/detail.vue"
export default component.exports